export default class ResultCenter {
  id: string;

  name: string;

  constructor(obj: any) {
    this.id = obj.id
    this.name = obj.name
  }

  public static of(obj: any): ResultCenter {
    return new ResultCenter(obj || {})
  }

  public static ofList(obj: any[]): ResultCenter[] {
    return obj.map(this.of)
  }
}
